import { INVALID_CHECKOUT_REASONS } from '@/consts/checkout';
import type {
  PaymentErrorResponse,
  ValidationErrorResponse,
} from '@/types/productSelectionAndCheckout/types';

const DEFAULT_MESSAGE = 'A system error occurred. Please try again.';

// Order matters: first matched key wins when picking a single message.
const KNOWN_ERROR_KEYS = Object.values(
  INVALID_CHECKOUT_REASONS,
) as readonly string[];

export function getPaymentErrorMessage(
  data?: PaymentErrorResponse | null,
  fallback = DEFAULT_MESSAGE,
): string {
  if (!data) {
    return fallback;
  }

  const errors = (data as ValidationErrorResponse).errors;
  if (errors && typeof errors === 'object') {
    for (const key of KNOWN_ERROR_KEYS) {
      const messages = errors[key];
      if (Array.isArray(messages) && messages.length > 0 && messages[0]) {
        return String(messages[0]);
      }
    }
    const firstMessages = Object.values(errors).flat().filter(Boolean);
    if (firstMessages.length > 0) {
      return String(firstMessages[0]);
    }
  }

  const summary = data.message?.trim();
  if (summary) {
    return summary;
  }

  return fallback;
}
